module.exports = __webpack_public_path__ + "static/media/loader.a497b88e.svg";